module.exports = __webpack_public_path__ + "img/icon-arrow-right.2d4b00c8.svg";